import React from "react";
import "./AdvisoryCouncilCard.css";

const AdvisoryCouncilCard = ({ item }) => {
  return (
    <div className="border mainRowCol w-100 d-flex flex-column">
      <div className="card-content position-absolute mainLinkEdin">
        <a href={item.linkedin} target="_blank" rel="noopener noreferrer">
          <div className="btnadvisory">
            <svg
              fill="currentColor"
              viewBox="0 0 1024 1024"
              className="mt-3 p-2 btn-I-ad"
              height="50"
              width="50"
            >
              <path d="M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.4-433c-37.9 0-68.8-30.8-68.8-68.8a68.8 68.8 0 1 1 137.6 0c0 38-30.8 68.8-68.8 68.8zm503.3 433H674.6V604.8c0-49.8-9.5-98-71.2-98-60.8 0-61.7 56.9-61.7 101.2v185.7H423.7V411.9h113.9v52.2h1.6c15.9-30 54.6-61.7 112.3-61.7 120.1 0 142.3 79.1 142.3 181.9v209.4z"></path>
            </svg>
          </div>
        </a>
      </div>

      <img
        src={item.imageUrl}
        alt={item.title}
        className="img-fluid mainImgPort"
      />

      <div className="advisory-card-content">
        <h3 className="advisory-card-title">{item.title}</h3>
        <p className="advisory-card-description">{item.description}</p>
      </div>
    </div>
  );
};

export default AdvisoryCouncilCard;